import { cn } from '@/lib/utils';

type DurationCountdownProps = {
  isRecording: boolean;
  secondsRemaining: number;
};

function formatMmSs(totalSeconds: number): string {
  const safe = Math.max(0, Math.floor(totalSeconds));
  const minutes = Math.floor(safe / 60);
  const seconds = safe % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

export function DurationCountdown({
  isRecording,
  secondsRemaining,
}: DurationCountdownProps) {
  if (!isRecording) return null;

  return (
    <div
      className={cn(
        'absolute top-3 right-3 z-30',
        'rounded-full bg-black/55 px-3 py-1',
        'text-white text-sm font-bold tabular-nums tracking-wide',
        'pointer-events-none',
      )}
    >
      {formatMmSs(secondsRemaining)}
    </div>
  );
}

export default DurationCountdown;
